import { Analytics } from '@vercel/analytics/react';
import { isSandboxDataNotice } from '@/lib/sandboxData';

/**
 * Vercel Web Analytics, switched off on the synthetic-sandbox staging build
 * (D70 FE6) so staging traffic never reaches production's analytics project.
 */
export function VercelAnalytics() {
  if (isSandboxDataNotice()) return null;
  return <Analytics debug={import.meta.env.DEV} />;
}
